import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { useOfferingSidePanelMatch } from './hooks/useOfferingSidePanelMatch';
import BuySideOfferingDetailsRoute from './offering-details/BuySideOfferingDetailsRoute';
import OfferingNotesRoute from './offering-notes/OfferingNotesRoute';
import offeringSidePanelBuySideRouteFactory from './offeringSidePanelBuySideRouteFactory';
import { OfferingSidePanelSummaryRoute } from './OfferingSidePanelSummaryRoute';
import OrderAllocationRoute from './order-allocation/OrderAllocationRoute';
import OrderBookBuySideRoute from './order-book/OrderBookBuySideRoute';

/**
 * `rest` isn't a real router location (see hooks/useOfferingSidePanelMatch.ts) — `<Routes
 * location={rest}>` matches against it explicitly instead of the actual browser location.
 */
const OfferingSidePanelBuySideRoutes: React.FC = () => {
  const sidePanelMatch = useOfferingSidePanelMatch();
  const rest = sidePanelMatch?.rest || '/';

  return (
    <Routes location={rest}>
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.offeringNotes.routePath}/*`}
        element={<OfferingNotesRoute />}
      />
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.orderBook.routePath}/*`}
        element={<OrderBookBuySideRoute />}
      />
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.offeringDetails.routePath}/*`}
        element={<BuySideOfferingDetailsRoute />}
      />
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.orderAllocation.routePath}/*`}
        element={<OrderAllocationRoute />}
      />
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.offeringSummary.routePath}/*`}
        element={<OfferingSidePanelSummaryRoute />}
      />
      <Route path="*" element={null} />
    </Routes>
  );
};

export default OfferingSidePanelBuySideRoutes;
